import React from 'react';
import PropTypes from 'prop-types';
import './NavBarItem.scss';
import { Link, useLocation } from 'react-router-dom';
import { useDataLayerValue } from '../../../DataLayer';


function NavBarItemCollection(props) {
    const [{ lang }] = useDataLayerValue();
    const localtion = useLocation();
    return (
        <div className={`nav-bar-item ${localtion.pathname === '/collection/library' ? 'active-link' : ''}`}>
            <Link to="/collection/library" className="link-subtle" draggable="false" >
                {localtion.pathname === '/collection/library' ? (<div className="icon active-icon">
                    <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M311.873 77.46l166.349 373.587-39.111 17.27-166.349-373.587zM64 463.746v-384h42.666v384h-42.666zM170.667 463.746v-384h42.667v384h-42.666z" fill="currentColor"></path>
                    </svg>
                </div>) : (<div className="icon ">
                    <svg viewBox="0 0 512 512" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M291.301 81.778l166.349 373.587-19.301 8.635-166.349-373.587zM64 463.746v-384h21.334v384h-21.334zM192 463.746v-384h21.334v384h-21.334z" fill="currentColor"></path>
                    </svg>
                </div>)
                }
                <span className="ellipsis-one-line" as="span">{lang === 'en' ? 'Your Library' : 'Thư viện'}</span>
            </Link>
        </div>
    );
}

export default NavBarItemCollection;